<template>
  <div>
    <ul class="list">
      <li v-for="item of list" :key="item.cat_id" @click="routerTo(item.cat_id)">
        <img :src="item.cat_pic" loading="lazy" />
        <p>{{ item.cat_name }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {

  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    routerTo (cat_id) {
      this.$router.push({
        name: 'Product',
        query: {
          cate_type: 2,
          type: 'cate',
          cat_id: cat_id
        }

      })
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  font-size: 0.28rem;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  padding: 0.2rem 0;
  border-radius: 20px;
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));

  li {
    margin: 0.15rem 0.2rem;
    text-align: center;

    img {
      width: 1.2rem;
      height: 1.2rem;
    }
  }
}
</style>